import React from 'react'
import { withApp } from 'helpers'
//import { withScroll } from 'helpers'
import img00 from 'assets/img/parallax.svg'
import img01 from 'assets/img/parallax01.svg'
import img02 from 'assets/img/parallax02.svg'
import img03 from 'assets/img/parallax03.svg'
import img04 from 'assets/img/parallax04.svg'
import img05 from 'assets/img/parallax05.svg'
import img06 from 'assets/img/parallax06.svg'
import './AppParallax.css'

const AppParallax = props => {
  //const style = { transform: `translate3d(0,${Math.min(400, props.scroll.top / 10)}px,0)` }

  const themes = {
    white: img00,
    default: img01,
    alternative: img01,
    orange: img02,
    purple: img03,
    blue: img04,
    cyan: img05,
    pink: img06,
  }

  const top = props.app.location && props.app.location.label === 'intro' ? '-160rem' : '-90rem'
  const style = props.app.location && props.app.location.label === 'intro' ? { backgroundImage: `url(${props.app.background.image})`, ...props.app.background.style } : {}
  const theme = props.app.location && props.app.location.label === 'intro' ? themes['white'] : themes[props.app.theme]

  return (
    <React.Fragment>
      <div className="App-parallax" style={style}>
        <div className="App-parallax-layer" style={{ backgroundImage: `url(${theme})`, top }} />

        <div style={{ backgroundImage: `url(${img00})` }}></div>
        <div style={{ backgroundImage: `url(${img01})` }}></div>
        <div style={{ backgroundImage: `url(${img02})` }}></div>
        <div style={{ backgroundImage: `url(${img03})` }}></div>
        <div style={{ backgroundImage: `url(${img04})` }}></div>
        <div style={{ backgroundImage: `url(${img05})` }}></div>
        <div style={{ backgroundImage: `url(${img06})` }}></div>
      </div>
    </React.Fragment>
  )
}

export default withApp(AppParallax) //withScroll(AppParallax)



// WEBPACK FOOTER //
// ./src/components/layout/parallax/AppParallax.js